import i18n from 'i18next';
import { initReactI18next } from "react-i18next/hooks";

import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import moment from "moment";
import pl from "moment/locale/pl";
import en from "moment/locale/en-gb";

const Languages = ['en', 'pl'];
i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        debug: true,
        whitelist: Languages,
        interpolation: {
            escapeValue: false
        },
        react: {
            useSuspense: false
        }
    });

i18n.on('languageChanged', (lng) => {
    moment.locale(lng)
});

export default i18n;
